import {
  deleteGoalsId,
  getGoals,
  getGoalsId,
  postGoals,
  putGoalsId,
} from '@/api/generated/fintecyWealthManagerAPI';
import { Goal, PostGoalsBody, PutGoalsIdBody } from '@/api/generated/model';

export const goalsService = {
  getGoals: async (): Promise<Goal[]> => {
    return getGoals();
  },

  getGoal: async (id: string): Promise<Goal> => {
    return getGoalsId(id);
  },

  createGoal: async (goal: Partial<Goal>): Promise<Goal> => {
    return postGoals(goal as PostGoalsBody);
  },

  updateGoal: async (id: string, goal: Partial<Goal>): Promise<Goal> => {
    return putGoalsId(id, goal as PutGoalsIdBody);
  },

  deleteGoal: async (id: string): Promise<void> => {
    return deleteGoalsId(id);
  },
};
